import { customAxios } from "./customAxios";


/**
 * 경보 팝업 록
 * @returns 
 */
export const getUnAckAlarms = async(query)=>{
  const res = await customAxios.get('/api/equipmentAlerts/popup', {params : query});
  if (res.data) {
    return res.data;
  }
}

export const ackAlarm = async (body) => {
  const res = await customAxios.patch(`/api/equipmentAlerts/${body.id}/confirm-alarm`,body);
};

export const ackAlarms = async (body) => {
  const res = await customAxios.patch(`/api/equipmentAlerts/confirm-alarms`,body);
};